{
    "up.common.cancel": "Annuler",
    "up.common.confirm": "Confirmer",
    "up.common.start": "Démarrer",
    "up.common.end": "Terminer",
    "up.common.stop": "Arrêter",
    "up.common.copy": "Copier",
    "up.common.none": "Aucun",
    "up.common.tip": "Conseil",
    "up.common.success": "Succès",
    "up.common.fail": "Échec",
    "up.common.close": "Fermer",
    "up.common.preview": "Aperçu",
    "up.common.re-select": "Resélectionner",
    "up.common.rotate": "Rotation",
    "up.common.pleaseChoose": "Veuillez choisir",
    "up.common.loading": "Chargement",
    "up.common.loading2": "Chargement en cours",
    "up.common.inOperation": "En cours d'opération",
    "up.common.settings": "Paramètres",
    "up.common.retry": "Réessayer",
    "up.common.search": "Rechercher",
    "up.common.more": "Plus",
    "up.common.video": "Vidéo",
    "up.common.file": "Fichier",
    "up.week.one": "Lun",
    "up.week.two": "Mar",
    "up.week.three": "Mer",
    "up.week.four": "Jeu",
    "up.week.five": "Ven",
    "up.week.six": "Sam",
    "up.week.seven": "Dim",
    "up.barcode.error": "Échec de génération du code-barres",
    "up.calendar.chooseDates": "Sélection de dates",
    "up.calendar.disabled": "Cette date est désactivée",
    "up.calendar.daysExceed": "Le nombre de jours sélectionnés ne peut pas dépasser {days} jours",
    "up.cityLocate.locateCity": "Localiser la ville",
    "up.cityLocate.fail": "Échec de localisation, veuillez cliquer pour réessayer.",
    "up.cityLocate.locating": "Localisation en cours",
    "up.code.send": "Obtenir le code de vérification",
    "up.code.resendAfter": "Renvoyer dans X secondes",
    "up.code.resend": "Renvoyer",
    "up.cropper.emptyWidhtOrHeight": "La largeur ou la hauteur de recadrage n'est pas définie",
    "up.empty.car": "Panier vide",
    "up.empty.page": "Page introuvable",
    "up.empty.search": "Aucun résultat de recherche",
    "up.empty.address": "Aucune adresse de livraison",
    "up.empty.wifi": "Aucun Wi-Fi",
    "up.empty.order": "Commande vide",
    "up.empty.coupon": "Aucun coupon",
    "up.empty.favor": "Aucun favori",
    "up.empty.permission": "Aucune autorisation",
    "up.empty.history": "Aucun historique",
    "up.empty.news": "Aucune actualité",
    "up.empty.message": "Liste de messages vide",
    "up.empty.list": "Liste vide",
    "up.empty.data": "Données vides",
    "up.empty.comment": "Aucun commentaire",
    "up.link.copyed": "Lien copié, veuillez ouvrir dans le navigateur",
    "up.loadmoe.loadmore": "Charger plus",
    "up.loadmoe.nomore": "Plus de contenu",
    "up.noNetwork.text": "Oups, le signal réseau est perdu",
    "up.noNetwork.pleaseCheck": "Veuillez vérifier le réseau, ou aller à",
    "up.noNetwork.connect": "Réseau connecté",
    "up.noNetwork.disconnect": "Aucune connexion réseau",
    "up.pagination.previous": "Page précédente",
    "up.pagination.next": "Page suivante",
    "up.pullRefresh.pull": "Tirer pour actualiser",
    "up.pullRefresh.release": "Relâcher pour actualiser",
    "up.pullRefresh.refreshing": "Actualisation en cours",
    "up.readMore.expand": "Développer pour lire la suite",
    "up.readMore.fold": "Réduire",
    "up.search.placeholder": "Veuillez saisir un mot-clé",
    "up.signature.penSize": "Taille du trait",
    "up.signature.penColor": "Couleur du trait",
    "up.upload.sizeExceed": "Dépassement de la limite de taille",
    "up.upload.uploading": "Téléchargement en cours",
    "up.upload.previewImageFail": "Échec de l'aperçu de l'image",
    "up.upload.previewVideoFail": "Échec de l'aperçu de la vidéo",
    "up.goodsSku.stock": "Stock",
    "up.goodsSku.price": "Prix",
    "up.goodsSku.amount": "Pièces",
    "up.goodsSku.choosed": "Sélectionné",
    "up.goodsSku.buyAmount": "Quantité"
}